
export enum InstallationWeekFilterEnum {
    ALL = 'ALL', FINISHED = 'FINISHED', OPENED = 'OPENED', OPENED_THIS_AND_NEXT_WEEK = 'OPENED_THIS_AND_NEXT_WEEK'
}
